export default __webpack_public_path__ + "static/media/pic6.7aa1f87d.jpg";